import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import ATextContainer from '../../atoms/_atoms.text-container';
import OProductDetailList from './_organisme.product-detail-list';
import MATexLogo from '../../molecules/_molecules.atex-logo';

export default function OProductDetailInfo({
	title,
	price,
	description,
	items,
	atex,
}) {
	return (
		<section className="o-product-detail-info">
			<ATextContainer
				title={title}
				description={description}
				translate={false}
				dangerouslyDescription
			/>
			<OProductDetailList
				items={items}
				price={price}
				className="o-product-detail-info--list"
			/>

			<article className="o-product-detail-atex">
				<ul>
					{
						atex.map(icon => (
							<li key={get(icon, 'alt', '')}>
								<MATexLogo
									src={get(icon, 'image.url', '')}
									alt={get(icon, 'name', '')}
									tooltip={get(icon, 'tooltip', '')}
								/>
							</li>
						))
					}
				</ul>

			</article>
		</section>
	);
}

OProductDetailInfo.propTypes = {
	title: PropTypes.string.isRequired,
	price: PropTypes.number,
	description: PropTypes.string.isRequired,
	items: PropTypes.array,
	atex: PropTypes.array,
};

OProductDetailInfo.defaultProps = {
	items: [],
	atex: [],
	price: undefined,
};




// WEBPACK FOOTER //
// ./src/components/organisme/product/_organisme.product-detail-info.js